export default __webpack_public_path__ + "static/media/01.c9c6d41d.png";